"use client";
// РУКА 2 (по решению Имы, 22.10). Логотип в шапке: одно нажатие — на главную, пять подряд за 5 секунд — страница
// входа в админку. Без входа сотрудника или кода разработчика админка не откроется — это только короткий путь к ней.
import type { ReactNode } from "react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { countTap } from "./tapCounter";

// Нажатия храним в памяти вкладки (sessionStorage): шапка может перестроиться или страница перезагрузиться
// после первого нажатия (оно ведёт на главную) — счёт не теряется. Нет доступа к хранилищу — просто в памяти.
const KEY = "logo-taps";
let memo: number[] = [];
function readTaps(): number[] {
  try {
    const v = JSON.parse(sessionStorage.getItem(KEY) ?? "[]");
    return Array.isArray(v) ? v.filter((x) => typeof x === "number") : memo;
  } catch {
    return memo;
  }
}
function writeTaps(t: number[]) {
  memo = t;
  try {
    sessionStorage.setItem(KEY, JSON.stringify(t));
  } catch {
    // приватный режим — остаёмся на памяти
  }
}

export function LogoLink({ children }: { children: ReactNode }) {
  const router = useRouter();
  return (
    <Link
      className="logo"
      href="/"
      onClick={(e) => {
        const r = countTap(readTaps(), Date.now());
        writeTaps(r.taps);
        if (r.fire) {
          e.preventDefault();
          router.push("/admin");
        }
      }}
    >
      {children}
    </Link>
  );
}
